import React from 'react';
import { Col as AntCol } from 'antd';
import type { ColProps } from 'antd';
import clsx from 'clsx';

export const Col = ({ className, ...props }: ColProps) => (
  <AntCol {...props} className={clsx('wk-col', className)} />
);
